import { Link } from "react-router-dom";
import { useState,useEffect } from "react";
import LinkCard from '../components/LinkCard'
import ghadminapi from '../api/ghadminapi';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";


function HomeAdmin({ accessToken,setAccessToken, setRefreshFailed, allowedPages,fullName,currentGuestHouse,setCurrentGuestHouse,currentMonth,setCurrentMonth,currentYear,setCurrentYear}) {
  const links = new Set();
  let showDropdown = false;
  let isAdmin=false;
  allowedPages.forEach((e) => {
    if (e === "all") {
      showDropdown = true;
      isAdmin=true;
      links.add({ path: `/guesthousedetails/${currentGuestHouse}`, label: "Guest House Details" });
      links.add({ path: `/admingstbills/${"GSTBILLS"}/${currentGuestHouse}`, label: "GST BILLS",billType:'gst' });
      links.add({ path: `/admingstbills/${"RETAILBILLS"}/${currentGuestHouse}`, label: "RETAIL BILLS",billType:'retail' });
      links.add({ path: `/admingstbills/${"CASHMEMOBILLS"}/${currentGuestHouse}`, label: "CASHMEMO BILLS",billType:'cashmemo' });
      links.add({ path: `/cancelledbills/${currentGuestHouse}`, label: "CANCELLED BILLS",billType:'cancelledbills' });
    } else if (e === "manager") {
      links.add({ path: `/managergstbills/${"GSTBILLS"}`, label: "GST BILLS" });
      links.add({ path: `/managergstbills/${"RETAILBILLS"}`, label: "RETAIL BILLS" });
      links.add({ path: `/managergstbills/${"CASHMEMOBILLS"}`, label: "CASHMEMO BILLS" });
    } 
  });

  const [statLoaded,setStatLoaded]=useState(true);
  const [stat,setStat]=useState(null);
  const navigate = useNavigate();

   useEffect(() => {
        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
        const year = String(today.getFullYear());
      
        setCurrentMonth(month);
        setCurrentYear(year);
      }, []);

  const loadForms=async (currentGuestHouse,currentMonth,currentYear)=>{
    if(isAdmin)
    {
          setStatLoaded(false);
          try{       
            //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
            const response=await ghadminapi.post('/getThisMonthStat',{currentGuestHouse,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${accessToken}`}});  
            setStat(response.data.stat);
            setStatLoaded(true);
            //alert(JSON.stringify(response.data.stat));
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);            
                const nat=x['data']['accessToken'];
                const lt=x['data']['loginType'];
                //alert(nat);
                setAccessToken(nat);
                setRefreshFailed(false);  
                        
               
                  if(lt.toLowerCase()==="admin")
                    {
                          try{       
                            //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                            const response=await ghadminapi.post('/getThisMonthStat',{currentGuestHouse,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${nat}`}});   
                            setStat(response.data.stat);
                            setStatLoaded(true);
                            //alert(JSON.stringify(response.data.stat));
                        }
                        catch(err)
                        {
                          if( err.response.status===403)
                            {
                              navigate(`/accessdenied`); 
                            }
                          //alert('refresh failed unusual'+JSON.stringify(err));
                          setAccessToken('');
                          setRefreshFailed(true);  
                        }
                      }
                }
                catch(err)
                {
                  //alert('dd');
                  setAccessToken(''); 
                  setRefreshFailed(true);              
                }
            }         
             finally
                {
                  ////setIsAppLoaded(true);
                  //alert('app loaded'+accessToken);
                  setStatLoaded(true);
                }
              }
        }

       useEffect(() => {
           if (currentGuestHouse && currentMonth && currentYear) {
             loadForms(currentGuestHouse,currentMonth,currentYear);
           }
         }, [currentMonth,currentYear,currentGuestHouse]);

  return (
    <main className="flex flex-col items-center p-4">
      <div className="w-full border-b border-gray-200 flex flex-col text-center">
        <p className="text-xs sm:text-sm text-gray-400">Welcome</p>
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-400 mb-2">
          {fullName}
        </p>
        {showDropdown && (
          <div className="flex flex-col justify-center items-center mt-2 mb-2">
            <label htmlFor="type-select" className="text-sm mb-1 text-gray-500">Select Guest House</label>
            <select
              id="type-select"
              value={currentGuestHouse}
              onChange={(e) => setCurrentGuestHouse(e.target.value)}
              className="w-[200px] border border-gray-300 rounded-md px-2 py-1 text-sm"
            >
              <option value="HB">H.B. Guest House</option>
              <option value="SB">S.B. Guest House</option>
            </select>
            <p className="w-full text-center mt-2 text-sm text-gray-600">
              Showing details for{" "}
              <span className="font-bold text-red-700">
                {currentGuestHouse === "HB" ? "H.B. Guest House" : "S.B. Guest House"}
              </span>
            </p>
          </div>
        )}
      </div>

      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {[...links].map((link, index) => (
          <Link key={index} to={link.path}>
          <LinkCard label={link.label} billType={link.billType} stat={stat} currentMonth={currentMonth} currentYear={currentYear}/>
        </Link>
        ))}
      </div>
    </main>
  );
}

export default HomeAdmin;
